import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {RecordData, SelectData} from "../../../../../types/records-table.types";
import {contactFormFields} from "../../configs/contacts-modal-config";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatButton} from "@angular/material/button";
import {BaseModalService} from "../../../services/base-modal.service";
import {ContactsDialogData} from "../../types/contacts-modal.types";
import {defaultRecordData} from "../../../../../models/default-record-data";
import {FormFieldUpdate} from "../../../../../types/file.types";
import {platformUrls, PlatformUrlType} from "../../../../../models/platform-urls-config";

@Component({
  selector: 'div[app-form-contacts-modal]',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatButton
  ],
  templateUrl: './form-contacts-modal.component.html',
  styleUrl: './form-contacts-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormContactsModalComponent {
  contactFormGroup = input<FormGroup>(new FormGroup({}));
  contactData = input<RecordData>(defaultRecordData);
  contactsDialogData = input<ContactsDialogData>();
  telegramAccountIds = input<Array<SelectData>>([]);
  currentContactIndex = input<number>(0);
  selectedTabIndex = input<number>(0);
  isEditModeActive = input<boolean>(false);
  isNew = input<boolean>(false);
  handleUpdateData = output<FormFieldUpdate>();
  deleteContactClick = output<number>();
  handleAttachClick = output<void>();

  private baseModalService: BaseModalService = inject(BaseModalService);

  public readonly contactFormFields = contactFormFields;

  public getClasses(): string {
    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public getFieldStyles(key: string): string {
    if (this.isEditModeActive()) { return ''; }

    return this.isActiveLinkRowForUrlType(key) && this.contactFormGroup().get(key)?.value ? 'pointer' : 'default'
  }

  public handleOpenUrlClick(key: string): void {
    if (this.isEditModeActive()) { return; }

    if (!this.isActiveLinkRowForUrlType(key)) { return; }

    if (key === 'phoneNumber') {
      this.baseModalService.initiateCall(key, this.contactFormGroup());
      return;
    }

    this.baseModalService.openUrlInNewTab(key, this.contactFormGroup());
  }

  public async handleFieldChange(key: string): Promise<void> {
    if (this.isNew()) { return; }

    const newValue = this.contactFormGroup().get(key)?.value;
    this.handleUpdateData.emit({ key, newValue });
  }

  public handleDeleteContact(index: number): void {
    this.deleteContactClick.emit(index);
  }

  private isActiveLinkRowForUrlType(type: string): boolean {
    return !this.isEditModeActive() && platformUrls.includes(type as PlatformUrlType);
  }
}
